import PropTypes from 'prop-types';
import { format } from 'date-fns';
import {
  Avatar,
  Box,
  Card,
  Checkbox,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography
} from '@mui/material';
import { Scrollbar } from 'src/components/scrollbar';
import { getInitials } from 'src/utils/get-initials';
import { useState } from 'react';
import PaymentDetails from 'src/pages/payment-details';
import RiderRideHistory from 'src/pages/rider-ride-history';
import { useNavigate } from 'react-router-dom';

export const PaymentTable = (props) => {

  const {
    count = 0,
    items = [],

    onPageChange = () => { },
    onRowsPerPageChange,

    page = 0,
    rowsPerPage = 0,
    selected = []
  } = props;

  const selectedSome = (selected.length > 0) && (selected.length < items.length);
  const selectedAll = (items.length > 0) && (selected.length === items.length);

  const [isPaymentHistoryPopUpOpen, setIsPaymentHistoryPopUpOpen] = useState(false);
  const [isRideHistoryPopUpOpen, setIsRiderHistoryPopUpOpen] = useState(false);
  const router = useNavigate();
  const [riderId, setRiderId] = useState();
  const paymentDetails = (riderId) => {
    setRiderId(riderId);
    setIsPaymentHistoryPopUpOpen(!isPaymentHistoryPopUpOpen);
  }


  const rideHistory = (riderId) => {
    setRiderId(riderId);
    setIsRiderHistoryPopUpOpen(!isRideHistoryPopUpOpen);

  }

  return (
    <Card>
      <>
        <Box sx={{ minWidth: 800 }}>
          <Table>
            <TableHead>
              <TableRow>

                <TableCell>
                  Name
                </TableCell>
                <TableCell>
                  Email
                </TableCell>
                <TableCell>
                  Location
                </TableCell>
                <TableCell>
                  Phone
                </TableCell>
                <TableCell>
                  Created Date
                </TableCell>
                <TableCell>
                  View
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {items.map((customer) => {
                const isSelected = selected.includes(customer.id);
                const createdAt = format(new Date(customer.created_at), 'dd/MM/yyyy');
                return (
                  <TableRow
                    hover
                    key={customer.id}
                    selected={isSelected}
                  >

                    <TableCell>
                      <Stack
                        alignItems="center"
                        direction="row"
                        spacing={2}
                      >

                        <Typography variant="subtitle2">
                          {customer.full_name}
                        </Typography>
                      </Stack>
                    </TableCell>
                    <TableCell>
                      {customer.email}
                    </TableCell>
                    <TableCell>
                      {customer.address}
                    </TableCell>
                    <TableCell>
                      {customer.phone_number ?? "No Phone Number"}
                    </TableCell>
                    <TableCell>
                      {createdAt}
                    </TableCell>
                    <TableCell>
                      <div className="flex space-x-2">
                        <button
                          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded transition duration-300 ease-in-out transform hover:scale-105"
                          onClick={() => paymentDetails(customer.id)}
                        >
                          Payment History
                        </button>
                        <button
                          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded transition duration-300 ease-in-out transform hover:scale-105"
                          onClick={() => rideHistory(customer.id)}
                        >
                          Ride History
                        </button>
                      </div>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </Box>
      </>
      {/* <TablePagination
        component="div"
        count={count}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
        page={page}
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={[5, 10, 25]}
      /> */}
      {
        isPaymentHistoryPopUpOpen && (
          <PaymentDetails riderId={riderId} isOpen={isPaymentHistoryPopUpOpen} onClose={paymentDetails} />
        )
      }

      {
        isRideHistoryPopUpOpen && (
          <RiderRideHistory riderId={riderId} isOpen={isRideHistoryPopUpOpen} onClose={rideHistory} />
        )
      }
    </Card>

  );
};

PaymentTable.propTypes = {
  count: PropTypes.number,
  items: PropTypes.array,
  onDeselectAll: PropTypes.func,
  onDeselectOne: PropTypes.func,
  onPageChange: PropTypes.func,
  onRowsPerPageChange: PropTypes.func,
  onSelectAll: PropTypes.func,
  onSelectOne: PropTypes.func,
  page: PropTypes.number,
  rowsPerPage: PropTypes.number,
  selected: PropTypes.array
};
